/** Auto-generated by scripts/sync-build-info.mjs — do not edit by hand. */
export const BUILD_META = {
  appVersion: '1.0.0',
  buildTag: '90cba22f386e9e70b868337974d20472125c8688',
} as const;
